import { render, staticRenderFns } from "./take-assignment.vue?vue&type=template&id=58bb7296&scoped=true&"
import script from "./take-assignment.vue?vue&type=script&lang=js&"
export * from "./take-assignment.vue?vue&type=script&lang=js&"
import style0 from "./take-assignment.vue?vue&type=style&index=0&id=58bb7296&prod&scoped=true&lang=css&"
import style1 from "./take-assignment.vue?vue&type=style&index=1&id=58bb7296&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb7296",
  null
  
)

export default component.exports